import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ScreenSizeService } from "./screen-size.service";

let sidebarVisible = false;

@Injectable()
export class SidebarService {
  private screenSizeService: ScreenSizeService;
  private whatsNewVisible = false;
  private whatsNewChange: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    this.screenSizeService = ScreenSizeService.getInstance();
  }

  setOverlayStatus() {
    if (sidebarVisible) {
      if (this.screenSizeService.isMobileScreen) {
        document.getElementById("main-container-overlay").hidden = false;
      }
      document.querySelector("body").classList.add("sidebar-mobile-show");
    } else {
      if (this.screenSizeService.isMobileScreen) {
        document.getElementById("main-container-overlay").hidden = true;
      }
      document.querySelector("body").classList.remove("sidebar-mobile-show");
    }
  }

  public init(visible: boolean) {
    sidebarVisible = visible;
    document.getElementById("main-container-overlay").hidden = true;
  }

  public setStatus(visible: boolean) {
    sidebarVisible = visible;
    this.setOverlayStatus();
  }

  public toggleStatus() {
    sidebarVisible = !sidebarVisible;
    this.setOverlayStatus();
  }

  public toggleWhatsNew() {
    this.whatsNewVisible = !this.whatsNewVisible;
    this.whatsNewChange.next(this.whatsNewVisible);
  }

  public getWhatsNewStatus(): Observable<any> {
    return this.whatsNewChange.asObservable();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/sidebar.service.ts